import { useState, useEffect, useRef } from 'react'
import Card from '@mui/material/Card'
import Image from 'next/image'
import Link from 'next/link'
import dayjs from 'dayjs'

// ** Antdesign Imports
import { DatePicker } from 'antd'

// request
import { useAndroidDevicePagedData } from 'src/hooks/useAndroidDevicePagedData'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import { useTranslation } from 'src/utils/i18n'
import NoData from 'src/components/NoData'
import RangePickerBox from 'src/components/RangePickerBox'
import ContentLoading from 'src/components/ContentLoading'
import { buildTimeParams } from 'src/utils/dateRangeParams'

// 将日期按天分开
const dataResort = data => {
  // 定义空数组，用于存储新组装的数据
  let newArr = []

  let add = 978278400

  // 遍历数组
  data.forEach((item, i) => {
    // 默认当前操作的数据下标 -1
    let index = -1

    // 判断数组中是否已经存在当前遍历数据的时间
    let isExists = newArr.some((newItem, j) => {
      if (dayjs.unix(item.visitTime + add).format('YYYY-MM-DD') == newItem.visitTime) {
        // 存在就保存当前数据下标  用于插入数据
        index = j

        return true
      }
    })

    // 如果没有就存储一条新对象数据
    if (!isExists) {
      newArr.push({
        visitTime: dayjs.unix(item.visitTime + add).format('YYYY-MM-DD'),
        subList: [item]
      })
    } else {
      // 如果有就插入到已存在的对象中
      newArr[index].subList.push(item)
    }
  })

  // 返回新数组
  return newArr
}

const BrowserHistory = () => {
  const { t } = useTranslation('common')

  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false

  const [initHistoryData, setInitHistoryData] = useState([])

  const [historyData, setHistoryData] = useState([])

  const [selectData, setSelectData] = useState({
    id: 1,
    category: 'SAFARI_HISTORY',
    name: 'Safari',
    icon: '/images/history/chrome.png',
    contents: []
  })

  //筛选过的消息列表
  const [selectDataList, setSelectDataList] = useState([])

  const [active, setActive] = useState(0)


  // 拼接新数据
  const appendValue = (old, arr, nowDate) => {
    let newContents = []

    old.contents.forEach(item => {
      const nowData = arr[0].contents.find(item2 => item.date === item2.date)
      if (nowData !== undefined) {
        // 拼接 items 并排序
        const mergedItems = [...item.items, ...nowData.items].sort((a, b) => dayjs(a.time, 'HH:mm') - dayjs(b.time, 'HH:mm'))
        newContents.push({ date: item.date, items: mergedItems })
      } else {
        // 原来的 items 也排序一下
        const sortedItems = [...item.items].sort((a, b) => dayjs(a.time, 'HH:mm') - dayjs(b.time, 'HH:mm'))
        newContents.push({ date: item.date, items: sortedItems })
      }
    })

    // 处理 nowDate
    nowDate.forEach(date => {
      if (newContents.findIndex(item2 => item2.date === date) === -1) {
        const newData = arr[0].contents.find(item2 => item2.date === date)
        if (newData) {
          const sortedItems = [...newData.items].sort((a, b) => dayjs(a.time, 'HH:mm') - dayjs(b.time, 'HH:mm'))
          newContents.push({ date: date, items: sortedItems })
        }
      }
    })

    return { ...old, contents: newContents }
  }

  const { context, data: historyRecords, loading: isLoading, loadNext, setDateRange } = useAndroidDevicePagedData({
    source: 'cloud',
    category: 'CHROME_HISTORY',
    limit: 100
  })

  useEffect(() => {
    const groupedContents = historyRecords.reduce((acc, item) => {
      const dateKey = dayjs(item.time).format('YYYY/MM/DD')
      if (!acc[dateKey]) acc[dateKey] = []
      acc[dateKey].push({ ...item, time: dayjs.unix(item.time).format('HH:mm') })
      acc[dateKey].sort((a, b) => dayjs(a.time, 'HH:mm') - dayjs(b.time, 'HH:mm'))

      return acc
    }, {})
    const chromeData = {
      id: 2,
      category: 'CHROME_HISTORY',
      name: 'Chrome',
      icon: '/images/history/chrome.png',
      contents: Object.keys(groupedContents).map(date => ({ date, items: groupedContents[date] }))
    }
    setSelectData(chromeData)
    setSelectDataList(chromeData)
    setInitHistoryData([chromeData])
    setHistoryData([chromeData])
  }, [historyRecords])

  useEffect(() => {
    setActive(0)
    setSelectedDates(null)
    setAntdSelectedDates([])
    setSelectedDateIndex(undefined)
  }, [context?.requestKey])

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = scrollTop / (scrollHeight - clientHeight) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100) loadNext()
  }, [loadNext, scroll])

  const [selectedDates, setSelectedDates] = useState(null)
  const [antdSelectedDates, setAntdSelectedDates] = useState([])
  const [selectedDateIndex, setSelectedDateIndex] = useState()

  const { RangePicker } = DatePicker

  //选择日期范围
  const handleDateChange = (dates, dateStrings) => {
    const picked = dates && dates.length === 2 ? dates : []

    setAntdSelectedDates(picked)
    setSelectedDateIndex(picked.length === 2 ? 2 : undefined)

    // 走接口按日期重新拉取（不筛选时传 null）；列表会随 historyRecords 自动重建
    const { startTime, endTime } = buildTimeParams(picked)
    setDateRange(picked.length === 2 ? { startTime, endTime } : null)
  }

  // 处理当前选中数据
  const handleSelectClick = id => {
    setActive(id)

    let data = historyData.find((item, index) => {
      return index === id
    })

    setSelectData(data)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    const title = t('Browser history')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      <Card className='relative'>
        {isLoading ? (
          <div className='absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]'>
            <ContentLoading />
          </div>
        ) : null}
        <div className='flex flex-col md:flex-row w-full Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)]'>
          {/* left layout */}
          <div className='md:w-[300px] w-full'>
            {/* 时间选择器 */}
            <div className='w-full mt-[15px] flex flex-col justify-center px-[15px] border-b-[1px] border-[#E5E7EB]'>
              <div className='w-full flex justify-start'>
                {historyData && (
                  <RangePickerBox
                    value={antdSelectedDates}
                    onChange={handleDateChange}
                    onClear={() => {
                      setAntdSelectedDates([])
                      handleDateChange([])
                    }}
                  />
                )}
              </div>
              <div className='flex justify-center items-center w-full h-[48px] my-[15px]'>
                <div className='flex justify-center w-full h-full'>
                  {historyData.map((row, index) => (
                    <li
                      className={`flex items-center rounded-[6px] px-[20px] w-full hover:cursor-pointer ${active === index ? `bg-[#E5E5E5]` : `bg-[#fff]`
                        }`}
                      key={index}

                    // onClick={() => handleSelectClick(index)}
                    >
                      <div className=''>
                        <Image src={row.icon} width={30} height={30} alt='img' />
                      </div>
                      <div className='ml-[8px]'>
                        <span className='text-[#334062] text-[14px]'>{row.name}</span>
                      </div>
                    </li>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/* right layout */}
          <div ref={dom} className='flex flex-col flex-1 h-full overflow-y-auto  md:border-l-[1px] md:border-l-[#E5E7EB]'>
            <ul className='px-[15px] border-[#E5E7EB] pt-4'>
              {selectData?.contents !== null && selectData?.contents?.length > 0 ? (
                selectData.contents.map(row => (
                  <li className='flex flex-col w-full pb-[18px] mb-[18px] border-b-[1px]' key={row.id}>
                    <h2 className='text-[16px] text-[#80889D] font-[600] leading-[24px] mb-[18px]'>{row.date}</h2>
                    <div className='flex flex-col gap-y-[23px] h-full'>
                      {row.items.map((item, i) => (
                        <div key={i} className='flex w-full'>
                          {/* 左侧内容 */}
                          <div className='flex w-[70px] flex-shrink-0 justify-between items-center'>
                            <div className='text-[#646464] text-[14px]'>{item.time}</div>
                            <Image src={selectData.icon} width={18} height={18} alt='img' />
                          </div>

                          {/* 右侧内容 */}
                          <div
                            className='ml-2 flex-1'
                            style={{
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              width: '100%' // 确保文本宽度跟随父元素
                            }}
                          >
                            {/* <div>{item.title}</div> */}
                            <Link target='_blank' className='text-[#646464] text-[14px]' href={item.url}>
                              {item.url}
                            </Link>
                          </div>
                        </div>
                      ))}
                    </div>
                  </li>
                ))
              ) : (
                <>{(!selectDataList.contents || selectDataList.contents.length === 0) && <NoData />}</>
              )}
            </ul>
          </div>
        </div>
      </Card>
    </>
  )
}

export default BrowserHistory


